import { styled } from "@mui/material";
import { detailRowName } from "../classes.js";
const ColumnLabel = styled("div", {
  name: detailRowName,
  slot: "ColumnLabel",
  overridesResolver: (_props, styles) => styles.columnLabel
})(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  maxWidth: "50%"
}));
export {
  ColumnLabel
};
//# sourceMappingURL=ColumnLabel.js.map
